import { useEffect, useRef } from 'react';
import { inboxAPI } from '@/services/api/inbox/inbox';
import { INBOX_NOTIF } from '../constants';
import { useStore } from '@/redux/store';
import { reportDtCustomError, useHTTPError } from 'br2s-ui-common-utils-02';

interface InboxLoaderProps {
  setInboxCount: (count: number) => void;
}

const InboxTimer = ({ setInboxCount }: InboxLoaderProps) => {
  const { notificationCount } = useStore();
  const { handleHTTPError } = useHTTPError();

  const inboxTimer = INBOX_NOTIF.LOADING_TIMER;
  const inboxTimeout = useRef<number | null>(null);

  // istanbul ignore next
  const callInboxTimer = () => {
    if (inboxTimeout.current) {
      clearTimeout(inboxTimeout.current);
    }

    inboxTimeout.current = window.setTimeout(() => {
      inboxNotifAPI();
    }, inboxTimer);
  };

  const inboxNotifAPI = async () => {
    try {
      const response = await inboxAPI.notifCount();

      if (response?.status === 200) {
        const totalUnreadCount = response?.data.result.unreadCount;

        notificationCount(totalUnreadCount);
        setInboxCount(totalUnreadCount);
        callInboxTimer();
      }
    } catch (error) {
      console.error(error);
      reportDtCustomError('GenericHandledError', JSON.stringify(error));

      // istanbul ignore next
      handleHTTPError(error, {
        errorType: 'none',
      });
    }
  };

  useEffect(() => {
    inboxNotifAPI();

    return () => {
      clearTimeout(inboxTimeout.current as number);
    };
  }, []);

  return null;
};

export default InboxTimer;
